module.exports = __webpack_public_path__ + "img/banner-2.2ef31316.png";